// mailListReadToggle.ts — Cluster POSTFACH: gelesen/ungelesen umschalten (P9)
//
// Der Goldpunkt an der Zeile war bisher reine Anzeige. Er ist jetzt der
// Schalter, und der schaltet optimistisch: die Zeile ändert sich sofort, der
// Server folgt. Scheitert der Aufruf, wird exakt derselbe Weg rückwärts
// gegangen — deshalb liegt das Setzen hier als reine Funktion und nicht als
// zwei handgeschriebene `map`-Aufrufe im Erfolgs- und im Fehlerpfad.

/**
 * Lesestatus EINER Mail in einer Liste setzen. Ändert sich nichts, kommt die
 * unveränderte Liste zurück (identische Referenz) — die Mail-Liste hängt an
 * mehreren Quellen (Ordner, Suchtreffer, Vorgangs-Mails), und ein neues Array
 * je Quelle würde bei jedem Klick alle drei neu rendern lassen.
 */
export function setzeLesestatus<T extends { id: string; read: boolean }>(
    liste: T[],
    id: string,
    read: boolean,
): T[] {
    let getroffen = false;
    const next = liste.map((e) => {
        if (e.id !== id || e.read === read) return e;
        getroffen = true;
        return { ...e, read };
    });
    return getroffen ? next : liste;
}

/** Beschriftung des Schalters — benennt die AKTION, nicht den Zustand. */
export function leseSchalterLabel(read: boolean): string {
    return read ? "Als ungelesen markieren" : "Als gelesen markieren";
}
